import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearDeterminate({ uploadTime }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const incrementPerSecond = 100 / uploadTime;

        const timer = setInterval(() => {
            setProgress(oldProgress => {
                const newProgress = Math.min(oldProgress + incrementPerSecond, 100);
                if (newProgress === 100) {
                    clearInterval(timer);
                }
                return newProgress;
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [uploadTime]);

    return (
        <Box sx={{ width: '100%', position: 'absolute', bottom: 0 }}>
            <LinearProgress variant="determinate" value={progress} />
        </Box>
    );
}
